<div id="timeline-content">
  <div class="content-description">
    <h2>My Career</h2>
  </div>
  <div class="timelines">
    <div class="worktype-header">{{ sw_header | uppercase }}</div>
    <div class="timeline">
      <div
        *ngFor="let swjob of sw_jobs; let odd = odd; let even = even"
        class="container"
        [class.right]="odd"
        [class.left]="even"
      >
        <div class="content">
          <h2>{{ swjob.time }}</h2>
          <h3>{{ swjob.title }}</h3>
          <p *ngFor="let para of swjob.paras">{{ para }}</p>
        </div>
      </div>
    </div>

    <div class="worktype-header">{{ summer_header | uppercase }}</div>
    <div class="timeline">
      <div
        *ngFor="let summerjob of summer_jobs; let odd = odd; let even = even"
        class="container"
        [class.left]="odd"
        [class.right]="even"
      >
        <div class="content">
          <h2>{{ summerjob.time }}</h2>
          <h3>{{ summerjob.title }}</h3>
          <p *ngFor="let para of summerjob.paras">{{ para }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
